import Headers from '@service-victoria/component-library/components/Text/Heading';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

import { clampLines } from 'utils/style';

import { BannerProps } from './Banner';

export const BannerWrapper = styled.header<Partial<BannerProps>>`
  background-color: ${colors.orange};
  display: flex;
  align-items: flex-start;
  padding: 20px;

  @media ${device.isDesktop} {
    padding: 32px 20px;
    min-height: ${({ size }) => (size === 'small' ? '100px' : '178px')};
  }

  @media (min-width: 1254px) {
    padding: 32px 0 0 0;
  } ;
`;

export const HeadingText = styled(Headers.H1)`
  font-weight: bold;
  color: ${colors.white};
  line-height: 46px;
  letter-spacing: -0.24px;
  font-size: 30px;
  ${clampLines(2)}

  @media ${device.isTabletAndAbove} {
    letter-spacing: -0.27px;
    font-size: 40px;
  }
`;
